import flatpickr from "flatpickr";

export const datepicker = () => {

	let els = document.querySelectorAll('[data-datepicker]')

	if (!els.length || window.innerWidth < 960) return

	let today = new Date();
	let oldest = new Date();

	oldest.setFullYear(today.getFullYear() - 66)

	els.forEach(el => {
		flatpickr(el, {
			dateFormat: "Y-m-d",
			defaultDate: el.value || null,
			altInput: true,
			altFormat: "j F Y",
			minDate: oldest,
			maxDate: today,
			onReady: (selectedDates, dateStr, instance) => {
				instance.altInput.id = 'alt-dob'
				instance.altInput.name = 'alt-dob'
			}
		})
	})
}

export default () => { }
